var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhonePayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5556 11.6622H16.778C16.336 11.6622 15.912 11.8378 15.5995 12.1504C15.2869 12.463 15.1113 12.8869 15.1113 13.3289C15.1113 13.7709 15.2869 14.1949 15.5995 14.5074C15.912 14.82 16.336 14.9956 16.778 14.9956H17.8889C18.331 14.9956 18.7549 15.1712 19.0674 15.4837C19.38 15.7963 19.5556 16.2202 19.5556 16.6622C19.5556 17.1043 19.38 17.5282 19.0674 17.8408C18.7549 18.1533 18.331 18.3289 17.8889 18.3289H15.1113M17.3337 19.4398V18.3289M17.3337 11.6622V10.5508",
    stroke: "#FF395D",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 22.7734H5.11093C4.8163 22.7734 4.53373 22.6564 4.32539 22.4481C4.11704 22.2397 4 21.9571 4 21.6625V3.88437C4 3.58973 4.11704 3.30716 4.32539 3.09882C4.53373 2.89048 4.8163 2.77344 5.11093 2.77344H16.2219C16.3678 2.77337 16.5123 2.80205 16.6472 2.85785C16.782 2.91365 16.9045 2.99547 17.0078 3.09863C17.111 3.2018 17.1929 3.32429 17.2487 3.45911C17.3046 3.59393 17.3333 3.73844 17.3333 3.88437V6.10677",
    stroke: "#FF395D",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8886 2.77344H8.44434L9.00007 4.99584H12.3334L12.8886 2.77344Z",
    stroke: "#FF395D",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhonePayment);
export default __webpack_public_path__ + "static/media/phonePayment.970bfce1c5eb294104a4603ab60708c5.svg";
export { ForwardRef as ReactComponent };